import React, { useRef, useEffect } from 'react';
import { C, COLUMN_GROUPS } from './shared';

export default function ColumnToggle({ visible, onToggle, onSelectAll, onClearAll, isOpen, onToggleOpen }) {
  const ref = useRef(null);

  useEffect(() => {
    if (!isOpen) return;
    function handler(e) {
      if (ref.current && !ref.current.contains(e.target)) onToggleOpen();
    }
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [isOpen, onToggleOpen]);

  const btnStyle = {
    padding: '5px 10px', background: 'transparent', color: C.primary,
    border: `1px solid ${C.border}`, borderRadius: 6, fontSize: 12, cursor: 'pointer',
  };

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <button onClick={onToggleOpen} style={btnStyle}>
        ⚙ Columns ▾
      </button>

      {isOpen && (
        <div style={{
          position: 'absolute', right: 0, top: 'calc(100% + 4px)', zIndex: 200,
          background: '#fff', border: `1px solid ${C.border}`, borderRadius: 10,
          boxShadow: C.shadowMd, padding: '14px 16px', minWidth: 310, maxHeight: '80vh', overflowY: 'auto',
        }}>
          {COLUMN_GROUPS.map(group => (
            <div key={group.label} style={{ marginBottom: 12 }}>
              <div style={{
                fontSize: 11, color: C.textSm, fontWeight: 600, marginBottom: 6,
                textTransform: 'uppercase', letterSpacing: '0.05em',
              }}>
                {group.label}
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '5px 16px' }}>
                {group.cols.map(([col, label]) => (
                  <label key={col} style={{
                    display: 'flex', alignItems: 'center', gap: 5,
                    cursor: 'pointer', fontSize: 12, color: C.text,
                  }}>
                    <input
                      type="checkbox"
                      checked={!!visible[col]}
                      onChange={() => onToggle(col)}
                      style={{ accentColor: C.primary }}
                    />
                    {label}
                  </label>
                ))}
              </div>
            </div>
          ))}

          <div style={{ display: 'flex', gap: 8, borderTop: `1px solid ${C.border}`, paddingTop: 10, marginTop: 4 }}>
            <button style={btnStyle} onClick={onSelectAll}>Select All</button>
            <button style={btnStyle} onClick={onClearAll}>Clear All</button>
          </div>
        </div>
      )}
    </div>
  );
}
